import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Delta from 'quill-delta';
import getOperationOffset from '../utils/getOperationOffset';
export default function setMark(op, editor) {
  return new Delta().retain(getOperationOffset(op, editor)).retain(op.length, _defineProperty({}, op.mark.type, op.newProperties));
}